import { Packages } from '~shared/constants/pricing';

import { PricingPalette, PackageColors, PackageTheme, PricingTheme } from './types';

const pricingPalette: Required<PricingPalette> = {
  colors: {
    sabaeus: '#00BF6F',
    midnight: '#05467E',
    link: '#007FAA',
    arctic: '#2DCCD3',
    concord: '#671E75',
    raspberry: '#AC145A',
    bengal: '#F05B24',
    bumblebee: '#F9BE00',
    black: '#000000',
    charcoal: '#333E48',
    slate: '#6B787F',
    stone: '#9DA5AA',
    flint: '#D0D2D3',
    pebble: '#EDEEEE',
    canvas: '#F7F8FA',
    white: '#FFFFFF',
    navy: '#051C4F',
    dijon: '#F7E298',
  },
};

export const packageColors: PackageColors = {
  advantageAnnual: pricingPalette.colors.sabaeus,
  advantageMonthly: pricingPalette.colors.sabaeus,
  basic: pricingPalette.colors.slate,
  flex: pricingPalette.colors.arctic,
  enterprise: pricingPalette.colors.midnight,
  premierAnnual: pricingPalette.colors.midnight,
  starterMonthly: pricingPalette.colors.link,
  premierMonthly: pricingPalette.colors.midnight,
  starterAnnual: pricingPalette.colors.link,
  standardMonthly: pricingPalette.colors.arctic,
  standardAnnual: pricingPalette.colors.arctic,
  teamAdvantage: pricingPalette.colors.link,
  teamPremier: pricingPalette.colors.concord,
  forms: pricingPalette.colors.concord,
};

export const packageTheme: PackageTheme = {
  [Packages.AdvantageAnnual]: {
    primary: packageColors.advantageAnnual,
  },
  [Packages.AdvantageMonthly]: {
    primary: packageColors.advantageMonthly,
  },
  [Packages.Basic]: {
    primary: packageColors.basic,
  },
  [Packages.Enterprise]: {
    primary: packageColors.enterprise,
  },
  [Packages.PremierAnnual]: {
    primary: packageColors.premierAnnual,
  },
  [Packages.StarterMonthly]: {
    primary: packageColors.starterMonthly,
  },
  [Packages.PremierMonthly]: {
    primary: packageColors.premierMonthly,
  },
  [Packages.StarterAnnual]: {
    primary: packageColors.starterAnnual,
  },
  [Packages.StandardMonthly]: {
    primary: packageColors.standardMonthly,
  },
  [Packages.StandardAnnual]: {
    primary: packageColors.standardMonthly,
  },
  [Packages.TeamAdvantage]: {
    primary: packageColors.teamAdvantage,
  },
  [Packages.TeamPremier]: {
    primary: packageColors.teamPremier,
  },
  [Packages.Flex]: {
    primary: packageColors.standardMonthly,
  },
  [Packages.FormsAnnual]: {
    primary: packageColors.forms,
  },
  [Packages.FormsMonthly]: {
    primary: packageColors.forms,
  },
};

export function getPricingTheme(): PricingTheme {
  return {
    pricingPalette, // User defined theme
    packageColors,
    packageTheme,
  };
}
